import Vue from 'vue'
import axios from 'axios'
import Vueaxios from 'vue-axios'

Vue.use(Vueaxios, axios)
// const URL = 'http://localhost:9999/'
// const URL = 'https://maejam.extensionsoft.biz/'
const URL = location.protocol + '//' + window.location.hostname + '/'
export default {
  backupData (success, error) {
    Vue.axios.get(URL + 'api/backup/db').then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getReportFamily (obj, success, error) {
    Vue.axios.post(URL + 'api/report/incomeFamily', obj).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getreport (obj, success, error) {
    Vue.axios.post(URL + 'api/report/monthtrends', obj).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getReportIncome (obj, success, error) {
    Vue.axios.post(URL + 'api/report', obj).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  gettrends (obj, success, error) {
    Vue.axios.post(URL + 'api/report/trends', obj).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getFamilyCount (success, error) {
    Vue.axios.get(URL + 'api/report/family').then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getMemberCount (success, error) {
    Vue.axios.get(URL + 'api/report/people').then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getConfig (success, error) {
    Vue.axios.get(URL + 'api/config').then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  deleteuser (payload, success, error) {
    Vue.axios.delete(URL + 'api/users/' + payload).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  login (payload, success, error) {
    Vue.axios.post(URL + 'api/login', payload).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  User (success, error) {
    Vue.axios.get(URL + 'api/users').then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  Adduser (payload, success, error) {
    console.log(payload)
    Vue.axios.post(URL + 'api/users', payload).then(
      response => {
        success(response.data)
      },
      response => {
        console.log(response)
        error(response)
      }
    )
  },
  getusers (payload, success, error) {
    console.log(payload)
    Vue.axios.get(URL + 'api/users/' + payload).then(
      response => {
        success(response.data)
      },
      response => {
        console.log(response)
        error(response)
      }
    )
  },
  putuser (payload, success, error) {
    console.log(payload)
    Vue.axios.put(URL + 'api/users/', payload).then(
      response => {
        success(response.data)
      },
      response => {
        console.log(response)
        error(response)
      }
    )
  },
  prefix (success, error) {
    Vue.axios.get(URL + 'api/prefix').then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  gender (success, error) {
    Vue.axios.get(URL + 'api/gender').then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  role (success, error) {
    Vue.axios.get(URL + 'api/role').then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  config (success, error) {
    Vue.axios.get(URL + 'api/config').then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  familyDetail (success, error) {
    Vue.axios.get(URL + 'api/family').then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  familyById (payload, success, error) {
    Vue.axios.get(URL + 'api/family/' + payload).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  familyAdd (payload, success, error) {
    Vue.axios.post(URL + 'api/family', payload).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  familyEdit (payload, success, error) {
    Vue.axios.put(URL + 'api/family', payload).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  familyDelete (payload, success, error) {
    Vue.axios.delete(URL + 'api/family/' + payload).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  memberAdd (payload, success, error) {
    Vue.axios.post(URL + 'api/member', payload).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  memberEdit (payload, success, error) {
    Vue.axios.put(URL + 'api/member', payload).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  memberDelete (payload, success, error) {
    Vue.axios.delete(URL + 'api/member/' + payload).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  memberShow (payload, success, error) {
    Vue.axios.get(URL + 'api/member/' + payload).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  memberShowById (payload, success, error) {
    Vue.axios.get(URL + 'api/member/detail/' + payload).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  roundList (success, error) {
    Vue.axios.get(URL + 'api/round').then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  roundDelete (payload, success, error) {
    Vue.axios.delete(URL + 'api/round/' + payload).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  roundAdd (payload, success, error) {
    Vue.axios.post(URL + 'api/round', payload).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  roundEdit (payload, success, error) {
    Vue.axios.put(URL + 'api/round', payload).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  roundDetail (payload, success, error) {
    Vue.axios.get(URL + 'api/round/' + payload).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  incomeAll (success, error) {
    Vue.axios.get(URL + 'api/income').then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  incomeFamilyAll (success, error) {
    Vue.axios.get(URL + 'api/income/familyAll/').then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  incomeByFamily (payload, success, error) {
    Vue.axios.get(URL + 'api/income/' + payload).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  incomeAdd (payload, success, error) {
    Vue.axios.post(URL + 'api/income', payload).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  incomeEdit (payload, success, error) {
    Vue.axios.put(URL + 'api/income', payload).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  incomeDlete (payload, success, error) {
    Vue.axios.delete(URL + 'api/income/' + payload).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  incomeChioce (success, error) {
    Vue.axios.get(URL + 'api/income/chioce').then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  LoggedIn () {
    return !!sessionStorage.Username
  },
  Logout () {
    delete sessionStorage.Data
    delete sessionStorage.Username
  }
}



// WEBPACK FOOTER //
// ./src/service/service.js